import { useState } from "react";
import { topics } from "@/mocks/home";

export default function TopicWall() {
  const [active, setActive] = useState(0);
  const current = topics[active];

  return (
    <section className="border-t border-background-200/70 bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mb-8 flex scroll-mt-24 flex-col gap-3 md:mb-10 md:flex-row md:items-end md:justify-between" id="topics">
          <div>
            <p className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-widest2 text-accent-700">
              <span className="font-heading text-base">02</span>
              <span className="h-px w-6 bg-accent-500" />
            </p>
            <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              话题墙 · 按想看的状态挑
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-foreground-500 md:text-right">
            每张图不只一张图，还挂着一串标签。点击任一门类，先读懂这一栏在讲什么。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          {/* 标签墙 - 密集网格 */}
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:col-span-7 lg:grid-cols-2">
            {topics.map((t, i) => (
              <button
                type="button"
                key={t.name}
                onClick={() => setActive(i)}
                className={`group flex cursor-pointer items-center gap-3 rounded-lg border px-4 py-4 text-left transition-all ${
                  active === i
                    ? "border-primary-500 bg-background-50 shadow-none"
                    : "border-background-200 bg-background-50 hover:border-primary-300"
                }`}
              >
                <span
                  className={`grid h-11 w-11 shrink-0 place-items-center rounded-md ${
                    active === i
                      ? "bg-primary-500 text-background-50 dark:text-foreground-950"
                      : "bg-secondary-100 text-secondary-800"
                  }`}
                >
                  <i className={`${t.icon} text-xl`} />
                </span>
                <span className="min-w-0">
                  <span className="flex items-center gap-2">
                    <span className="font-heading text-base font-bold text-foreground-950">{t.name}</span>
                    <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-900">
                      {t.count}
                    </span>
                  </span>
                  <span className="mt-0.5 block truncate text-xs text-foreground-500">{t.desc}</span>
                </span>
              </button>
            ))}
          </div>

          {/* 选中话题说明 */}
          <div className="lg:col-span-5">
            <div className="relative overflow-hidden rounded-lg border border-background-200 bg-background-50 p-6 md:p-7">
              <span className="grid h-12 w-12 place-items-center rounded-md bg-primary-100 text-primary-700">
                <i className={`${current.icon} text-2xl`} />
              </span>
              <h3 className="mt-5 font-heading text-xl font-bold text-foreground-950">{current.name}</h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                {current.desc}。在「{current.name}」这一栏里，画面统一采用路人视角直出，
                弱化摆拍与磨皮，保留真实状态，方便你参考日常通勤与周末出街的质感。
              </p>
              <ul className="mt-5 space-y-2.5 text-sm text-foreground-600">
                <li className="flex items-start gap-2">
                  <i className="mt-0.5 text-accent-600 ri-checkbox-circle-line" />
                  路人视角直出，不摆拍不磨皮
                </li>
                <li className="flex items-start gap-2">
                  <i className="mt-0.5 text-accent-600 ri-checkbox-circle-line" />
                  标签即入口，点开直达对应栏目
                </li>
                <li className="flex items-start gap-2">
                  <i className="mt-0.5 text-accent-600 ri-checkbox-circle-line" />
                  同款穿搭可跳到下方一键生图对比
                </li>
              </ul>
              <a
                href="#street"
                className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
              >
                去看「{current.name}」栏目 <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}